import React, { Component } from 'react';
import { WithStyles, createStyles, Typography, Stepper, Step, StepConnector, StepLabel, LinearProgress, Button, Grid } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { MyPATCollapse } from '../../common';
import { Check, ErrorOutline } from '@material-ui/icons';
import { statusType } from '../types/ContentInSection';
import _ from 'lodash';
import PublishProgressModal from './ContentCreate/VideoCreate/PublishProgressModal'
import { CONTENT_STATES } from '../../../constants/comman';
import { showMsg as showAlert } from '../../course/actions/loaderAlert';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import classNames from 'classnames';
import { scrollIntoView } from '../../../utils';

const styles = (theme: Theme) =>
  createStyles({
    successIcon: {
      backgroundColor: "#379D0B",
    },
    primaryColor: {
      backgroundColor: theme.palette.primary.main,
    },
    warningIcon: {
      color: "#FF4A4A !important",
      padding: "0 !important",
      transform: "scale(1.3)",
    },
    positionAb: {
      position: "absolute",
      right: "5px",
      top: "4px",
      color: "#666666",
      textShadow: "0px 0px 2px #FFF",
      fontSize: "14px",
    },
    publishedLabel: {
      position: "absolute",
      right: "0",
      left: "0",
      top: "4px",
      color: "#666666",
      textShadow: "0px 0px 2px #FFF",
      fontSize: "14px",
      cursor: "pointer",
    },
    positionRl: {
      position: "relative",
    },
    icon: {
      color: theme.palette.primary.contrastText,
      borderRadius: 13,
      padding: "3px",
    },
    editIcon: {
      fontSize: 16,
    },
    connectorLine: {
      borderColor: "transparent",
      margin: "0px -2px 0px",
    },
    defaultIcon: {
      backgroundColor: theme.palette.primary.contrastText,
    },
    p15: {
      padding: theme.spacing.unit * 2,
      height: "auto",
      overflow: "auto",
    },
    overflowSection: {
      overflow: "auto",
      height: "auto",
      padding: theme.spacing.unit * 2,
      backgroundColor: '#fbfbfb',
    },
    innerConnecter: {
      "&:after": {
        minHeight: "32px",
        borderLeftStyle: "solid",
        borderLeftWidth: "1px",
        margin: "21px -10px -5px",
        borderColor: "#BDBDBD",
        content: '""',
        marginTop: "20px",
        position: "absolute",
      },
    },
    progressBar: {
      height: "5px",
      background: "#EDEDED",
      borderRadius: "18px",
      boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.193756)",
      minHeight: "5px",
      lineHeight: "5px",
      verticalAlign: "middle",
    },
    addOptionButton: {
      textAlign: "center",
    },
    moveToPlannedContainer: {
      marginTop: theme.spacing.unit * 3,
      marginBottom: theme.spacing.unit,
      marginLeft: -theme.spacing.unit * 2,
      marginRight: -theme.spacing.unit * 2,
      //paddingLeft: theme.spacing.unit * 2,
      //paddingRight: theme.spacing.unit * 2,
      position: "relative",
      borderTop: "1px solid #ededed",
    },
    moveToPlannedOr: {
      position: "absolute",
      left: "50%",
      transform: "translateY(-50%) translateX(-50%)",
      fontSize: "12px",
      background: "#ededed",
      color: "#adadad",
      //padding: theme.spacing.unit,
      borderRadius: "100%",
    },
    moveToPlanned: {
      borderRadius: "18px",
      width: "100%",
      marginTop: theme.spacing.unit * 4,
    },
    modalBody: {
      width: "900px",
      paddingBottom: "47px",
      paddingTop: "35px",
      textAlign: "center",
    },
    publishText: {
      fontWeight: "normal",
      fontSize: "16px",
      lineHeight: "24px",
      textAlign: "center",
      width: "577px",
      margin: "20px auto 0 auto",
      display: "block",
    },
    quesIdContainer: {
      padding: "15px",
      width: "100%",
      textAlign: "center",
    },
    quesId: {
      border: "solid 1px #2196F3",
      color: "#2196F3",
      padding: "5px 14px 5px 14px",
      textAlign: "center",
      fontSize: "16px",
      lineHeight: "16px",
      borderRadius: "4px",
      textDecoration: "none",
      margin: "10px",
      background: "#ffffff",
    },
    modalFooter: {
      textAlign: "center",
      padding: "10px 0 20px 0",
    },
    refreshBtn: {
      color: "#ffffff",
      padding: "0 16px",
      background: "linear-gradient(90deg, #2E93FB 0%, #66b4fd 70%)",
      height: "36px",
      fontSize: "0.875rem",
      minWidth: "64px",
      boxSizing: "border-box",
      lineHeight: "1.75",
      borderRadius: "4px",
      backgroundColor: "#2E93FB",
      border: "solid 1px #2E93FB",
      display: "inline-block",
      width: "140px",
    },
    okBtn: {
      color: "#2E93FB",
      padding: "0 16px",
      background: "#ffffff",
      height: "36px",
      fontSize: "0.875rem",
      minWidth: "64px",
      boxSizing: "border-box",
      lineHeight: "1.75",
      borderRadius: "4px",
      marginLeft: "18px",
      display: "inline-block",
      width: "140px",
      border: "solid 1px #2E93FB",
    },
    newsteps: {
      borderLeft: "solid 1px #bdbdbd",
      padding: "10px 0 0 10px",
      margin: "0px 0 0 10px",
    },
    borderLeftNew: {
      content: "",
      background: "#bdbdbd",
      position: "absolute",
      left: "-38px",
      top: "12px",
      width: "10px",
      "z-index": "7",
      height: "1px",
      display: "inline-block",
    },
    footerFixed: {
      position: "fixed",
      zIndex: 100,
      right: 0,
      width: "100%",
      bottom: 0,
      textAlign: "right",
      backgroundColor: "#ffffff",
      paddingRight: "26px",
      padding: "15px 24px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      display: "grid",
      gridTemplateColumns: "92% 8%",
      alignItems: "center",
      "& button": {
        padding: "10px 8px",
        maxWidth: 140,
        width: "100%",
      },
    },
    linearProgressBar: {
      borderRadius: 5,
      padding: 2,
      margin: "4px 8px",
      backgroundColor: "#E8E8E8",
      width: "82px",
      minWidth: 85,
      display: "inline-block",
      verticalAlign: "middle",
    },
    progressPercent: {
      fontSize: 14,
      color: "#333",
      fontWeight: 600,
    },
    colorSecondary: {
      backgroundColor: "#EB4F4F",
      color: "5.5px 5px 5px 5.5px",
    },
    colorprimary: {
      backgroundColor: "#67BF02",
    },
    colorSuccess: {
      backgroundColor: "#67BF02",
      color: "5.5px 5px 5px 5.5px",
    },
    progressLabel: {
      fontSize: 14,
      color: "#999",
    },
    progressCount: {
      fontSize: 14,
      color: "#333",
      fontWeight: 600,
    },
    progressParent: {
      display: "flex",
      alignItems: "center",
    },
    displayFlex: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      flexDirection: "row-reverse",
      maxWidth: 220,
      width: "100%",
      marginLeft: "auto",
    },
    cursorPointer: {
      cursor: "pointer",
    },
    numberLabel: {
      width: 28,
      height: 28,
      borderRadius: "50%",
      border: "1px solid #dcdcdc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    focusedStep: {
      backgroundColor: '#FAFCFF',
      padding: '10px 10px 10px 0',
      borderRadius: "4px",
    },
    clickable: {
      cursor: 'pointer !important'
    }
  });

interface audioSectionsInContentProps extends WithStyles<typeof styles> {
  classes: any,
  inContent: any,
  completionPercent: Function,
  formData: any,
  save: Function,
  showAlert: Function;
  focusedSection: { currentlyFocusedSection: string; sectionsTouched: Set<string> },
  queryParams: any;
}

interface audioSectionsInContentStates {
  isPublishaudioModalOpen: boolean,
  progressBarSetting: any
}

const totalPercentage = 100;
class audioSectionsInContent extends Component<audioSectionsInContentProps, audioSectionsInContentStates>{
  constructor(props: any) {
    super(props);
    this.state = {
      isPublishaudioModalOpen: false,
      progressBarSetting: { barLength: 0, barPercentage: 0 }
    }
  }

  componentDidMount = () => {
    this.calculateProgressBar();
  }

  componentDidUpdate = (prevProps: any, prevState: any) => {
    const {
      inContent,
    } = this.props;
    const {
      inContent: previousinContent,
    } = prevProps
    if (!_.isEqual(inContent, previousinContent) || localStorage.getItem('isConceptTagChanged') === 'true') {
      this.calculateProgressBar();
    }
  }

  stepLevelIconType = (type: statusType, sectionNo: number, subSectionNo: number | string, isCurrentlyEditing: boolean) => {
    let { classes } = this.props;
    let toShow = (sectionNo + 1).toString();
    if (subSectionNo !== '') {
      toShow = (parseInt(subSectionNo.toString()) + 1).toString()
    }
    if (isCurrentlyEditing) {
      return (<EditOutlinedIcon className={`${classes.icon} ${classes.primaryColor}`} />)
    }
    switch (type) {
      // case statusType.edit:
      //     return (<EditOutlinedIcon className={`${classes.icon} ${classes.primaryColor}`} />)
      // case statusType.warning:
      //     return (<ErrorOutline className={`${classes.icon} ${classes.warningIcon}`} />)
      case statusType.success:
        return (<Check className={`${classes.icon} ${classes.successIcon}`} />)
      default:
        return (<Typography className={classes.numberLabel} variant="body1">{toShow}</Typography>)
    }
  }

  onSectionClick = (sectionLabel: string) => {
    scrollIntoView(_.camelCase(sectionLabel));
  }


  stepLabelType = (label: string, type: statusType, sectionNo: number, subSectionNo: number | string = '') => {
    let { classes, focusedSection: { currentlyFocusedSection } } = this.props;
    const isCurrentlyEditing = _.camelCase(label) === currentlyFocusedSection;

    // if (type !== statusType.none || isCurrentlyEditing) {
    return (<StepLabel className={classNames(classes.clickable, isCurrentlyEditing && classes.focusedStep)} onClick={() => this.onSectionClick(label)} icon={this.stepLevelIconType(type, sectionNo, subSectionNo, isCurrentlyEditing)}><Typography className={classes.cursorPointer} variant="body1">{label}</Typography></StepLabel>)
    // }
    // else {
    //     return (<StepLabel className={classNames(classes.clickable, isCurrentlyEditing && classes.focusedStep)} onClick={() => this.onSectionClick(label)}><Typography variant="body1">{label}</Typography></StepLabel>)
    // }
  }

  validateCustomDescription = (description: any, instruction: any) => {
    let error: any = [];
    const mainContent = description.replace(/(&nbsp;|<([^>]+)>)/ig, '');
    const mainInstruction = instruction.replace(/(&nbsp;|<([^>]+)>)/ig, '');
    if (mainContent.length > 180) {
      error.push('Question description should not exceed 180 characters')
    }
    if (!mainInstruction.length) error.push('Question instruction is required')
    return error;
  }

  validateaudioContent = () => {
    const { formData } = this.props;
    let errorInQuestions = false;
    if (!formData.audioUrl || (formData.audioUrl && !formData.audioUrl.length)) {
      this.props.showAlert(' audio is required', 'error');
      return false
    }
    if (!formData.title || (formData.title && !formData.title.length)) {
      this.props.showAlert('Title is required', 'error');
      return false
    }
    if (!formData.description || !formData.description.length) {
      this.props.showAlert('Description is required', 'error');
      return false
    }
    if (formData.pageError) {
      const errorKeys: any[] = Object.values(formData.pageError);
      if (errorKeys.some((key: string): boolean => {
        if (key.length > 0) {
          this.props.showAlert(key, 'error');
          return true
        } return false
      })) return false
    }
    formData.pageState && Object.keys(formData.pageState).forEach((questionName, index) => {
      const pageState = formData.pageState[questionName];
      const questionValidationErrors = this.validateCustomDescription(pageState.description, pageState.instruction)
      if (questionValidationErrors.length) {
        questionValidationErrors.map((error: any) => this.props.showAlert(error, 'error'));
        errorInQuestions = true
        return;
      }
    })

    if (errorInQuestions) {
      return false
    }
    return true;
  }

  _onClickPublishButton = (e: any) => {
    const { progressBarSetting: { barPercentage } } = this.state;
    if (barPercentage >= 100) {
      const isValidData = this.validateaudioContent();
      if (!isValidData) return;
      this.handlePublishaudioModal(true);
    }
  }

  handlePublishaudioModal = (state: boolean) => {
    this.setState({
      isPublishaudioModalOpen: state
    })
  }

  calculateProgressBar() {
    let { progressBarSetting } = this.state;
    let { inContent, completionPercent } = this.props;

    progressBarSetting.barLength = 0;

    let numberOfSections = 0;
    inContent.forEach((step: any) => {
      if (step.subType && step.subType.length) {
        numberOfSections += step.subType.length
      }
      numberOfSections++
    });

    let eachSectionsPoints = totalPercentage / numberOfSections;
    inContent.forEach((step: any, i: any) => {
      if (step.subType && step.subType.length) {
        let successSubSteps = 0;
        step.subType.forEach((subStep: any) => {
          if (subStep.state === statusType.success) {
            successSubSteps++
            progressBarSetting.barLength += eachSectionsPoints;
          }
        })
        if ((statusType.success === step.state) && (step.subType.length === successSubSteps)) {
          progressBarSetting.barLength += eachSectionsPoints;
        }
      } else if (statusType.success === step.state) {
        progressBarSetting.barLength += eachSectionsPoints;
      }
    });
    progressBarSetting.barPercentage = parseInt(progressBarSetting.barLength, 10)
    this.setState({
      progressBarSetting: progressBarSetting
    });
    localStorage.removeItem('isConceptTagChanged');

    completionPercent(undefined, progressBarSetting.barPercentage);
  }

  publishButtonCustomStyle = (progressBarSetting: any) => {
    const style = { color: 'white', cursor: 'default', opacity: 0.6 }
    if (progressBarSetting.barPercentage >= totalPercentage) {
      style.cursor = "pointer"
      style.opacity = 1
    }
    return style;
  }

  render() {
    const { classes, inContent, formData } = this.props;
    const { isPublishaudioModalOpen, progressBarSetting } = this.state;
    return (
      // <MyPATCollapse title={<Typography variant="body2" component="h3">Sections in This Content</Typography>}>
      <>
        <Stepper
          className={classes.overflowSection}
          connector={
            <StepConnector
              classes={{
                disabled: classes.stepDisabled,
                line: classes.connectorLine,
              }}
            />
          }
          orientation="vertical"
        >
          {inContent.map((label: any, index: any) => (
            <Step key={index}>
              {this.stepLabelType(label.title, label.state, index)}
              {_.map(label.subType, (ob, i) => {
                if (ob.visible) {
                  return (
                    <Stepper
                      key={`${index}_${i}`}
                      className={classes.newsteps}
                      orientation="vertical"
                    >
                      <Step key={`${i}_${index}`}>
                        {this.stepLabelType(ob.title, ob.state, index, i)}
                      </Step>
                    </Stepper>
                  );
                }
              })}
            </Step>
          ))}
        </Stepper>
        {/* <div
              onClick={this._onClickPublishButton}
              className={classes.positionRl}
            >
              <LinearProgress
                classes={{ root: classes.progressBar }}
                variant="determinate"
                value={progressBarSetting.barLength}
              />
              <Typography
                className={classes.positionAb}
                variant="subtitle1"
                align="center"
              > */}
        {/* <span>Publish</span> */}
        {/* {progressBarSetting.barLength > 0 ? (
                  progressBarSetting.barLength >= 100 ? (
                    <Check
                      className={`${classes.icon} ${
                        classes.successIcon
                      }`}
                    />
                  ) : (
                    `${progressBarSetting.barPercentage}%`
                  )
                ) : (
                  "0%"
                )}
              </Typography> */}
        {/* <div>
                <Typography
                  style={this.publishButtonCustomStyle(
                    progressBarSetting
                  )}
                  className={classes.publishedLabel}
                  variant="subtitle1"
                  align="center"
                >
                  {formData.status === CONTENT_STATES.PUBLISHED
                    ? "Re-publish"
                    : "Publish"}
                </Typography>
              </div>
              <Typography variant="caption" align="center">
                Reach 100% progress to publish the content
              </Typography>
            </div> */}
            <PublishProgressModal
              forAudio={true}
              isPublishVideoModalOpen={isPublishaudioModalOpen}
              save={this.props.save}
              handlePublishVideoModal={this.handlePublishaudioModal}
            />

        <Grid container className={classes.footerFixed}>
          <Grid item>
            <Grid className={classes.displayFlex}>
              <LinearProgress
                classes={{
                  colorSecondary: classes.colorprimary,
                  barColorPrimary: classes.colorprimary,
                  bar: classes.progressBar,
                  root: classes.linearProgressBar,
                }}
                variant="determinate"
                value={progressBarSetting.barLength}
              />
              <Typography
                //   className={classes.positionAb}
                //   variant="subtitle1"
                align="center"
              >
                Progress: {progressBarSetting.barPercentage} %
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              disabled={progressBarSetting.barPercentage < totalPercentage}
              //   onClick={() => {
              //     this.publishButtonOnClick(progressBarSetting);

              //   }}
              onClick={this._onClickPublishButton}
            >
              {formData.status === CONTENT_STATES.PUBLISHED
                ? "Re-publish"
                : "Publish"}
            </Button>
          </Grid>
        </Grid>
        {/* </MyPATCollapse> */}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  focusedSection: state.commonData.focusedSection,
  inContent: _.get(state, 'audioDetailsInContentReducers', {}),
})

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  showAlert: showAlert,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(audioSectionsInContent));
